import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ChairmanMessage.css'; // Import custom CSS file
import API_URL from '../../api/ExamCalendarApi';

const ChairmanMessage = () => {
  const [aboutChairman, setAboutChairman] = useState('');
  const [chairmanMessage, setChairmanMessage] = useState('');
  const [chairmanPhoto, setChairmanPhoto] = useState(null);
  const [chairmanMessagePhoto, setChairmanMessagePhoto] = useState(null);
  const [chairmanMessageBanner, setChairmanMessageBanner] = useState(null);
  const [chairmanPhotoRedirect, setChairmanPhotoRedirect] = useState('');
  const [chairmanMessageRedirect, setChairmanMessageRedirect] = useState('');
  const [chairmanMessages, setChairmanMessages] = useState([]);
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchChairmanMessages();
  }, []);

  const fetchChairmanMessages = () => {
    axios.get(`${API_URL}/chairmanmessage/all`)
      .then(response => setChairmanMessages(response.data))
      .catch(error => console.error('Error fetching chairman messages:', error));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('aboutChairman', aboutChairman);
    formData.append('chairmanMessage', chairmanMessage);
    formData.append('chairmanPhotoRedirect', chairmanPhotoRedirect);
    formData.append('chairmanMessageRedirect', chairmanMessageRedirect);
    if (chairmanPhoto) formData.append('chairmanPhoto', chairmanPhoto);
    if (chairmanMessagePhoto) formData.append('chairmanMessagePhoto', chairmanMessagePhoto);
    if (chairmanMessageBanner) formData.append('chairmanMessageBanner', chairmanMessageBanner);

    if (editingId) {
      axios.put(`${API_URL}/chairmanmessage/edit/${editingId}`, formData)
        .then(() => {
          alert('Chairman message updated successfully!');
          fetchChairmanMessages();
          resetForm();
        })
        .catch(error => console.error('Error updating chairman message:', error));
    } else {
      axios.post(`${API_URL}/chairmanmessage/add`, formData)
        .then(response => {
          alert('Chairman message added successfully!');
          setChairmanMessages([...chairmanMessages, response.data]);
          resetForm();
        })
        .catch(error => console.error('Error adding chairman message:', error));
    }
  };

  const resetForm = () => {
    setAboutChairman('');
    setChairmanMessage('');
    setChairmanPhoto(null);
    setChairmanMessagePhoto(null);
    setChairmanMessageBanner(null);
    setChairmanPhotoRedirect('');
    setChairmanMessageRedirect('');
    setEditingId(null);
  };

  const handleEdit = (message) => {
    setEditingId(message._id);
    setAboutChairman(message.aboutChairman);
    setChairmanMessage(message.chairmanMessage);
    setChairmanPhotoRedirect(message.chairmanPhotoRedirect);
    setChairmanMessageRedirect(message.chairmanMessageRedirect);
    window.scrollTo(0, 0);
  };

  const handleDelete = (id) => {
    axios.delete(`${API_URL}/chairmanmessage/delete/${id}`)
      .then(() => {
        alert('Chairman message deleted successfully!');
        setChairmanMessages(chairmanMessages.filter(message => message._id !== id));
      })
      .catch(error => console.error('Error deleting chairman message:', error));
  };

  return (
    <div className="admin-chairmanmessage-container">
      <h2 className="admin-chairmanmessage-title">{editingId ? 'Edit Chairman Message' : 'Add Chairman Message'}</h2>

      <form onSubmit={handleSubmit} className="admin-chairmanmessage-form">
        <div className="admin-chairmanmessage-form-group">
          <label htmlFor="admin-chairmanmessage-aboutChairman">About Chairman:</label>
          <textarea
            id="aboutChairman"
            value={aboutChairman}
            onChange={e => setAboutChairman(e.target.value)}
            required
          />
        </div>

        <div className="admin-chairmanmessage-form-group">
          <label htmlFor="chairmanMessage">Chairman Message:</label>
          <textarea
            id="chairmanMessage"
            value={chairmanMessage}
            onChange={e => setChairmanMessage(e.target.value)}
            required
          />
        </div>

        <div className="admin-chairmanmessage-form-group">
          <label htmlFor="chairmanPhoto">Chairman Photo:</label>
          <input
            id="chairmanPhoto"
            type="file"
            accept="image/*"
            onChange={e => setChairmanPhoto(e.target.files[0])}
          />
        </div>

        <div className="admin-chairmanmessage-form-group">
          <label htmlFor="chairmanMessagePhoto">Chairman Message Photo:</label>
          <input
            id="chairmanMessagePhoto"
            type="file"
            accept="image/*"
            onChange={e => setChairmanMessagePhoto(e.target.files[0])}
          />
        </div>

        <div className="admin-chairmanmessage-form-group">
          <label htmlFor="chairmanMessageBanner">Chairman Message Banner:</label>
          <input
            id="chairmanMessageBanner"
            type="file"
            accept="image/*"
            onChange={e => setChairmanMessageBanner(e.target.files[0])}
          />
        </div>

        <div className="admin-chairmanmessage-form-group">
          <label htmlFor="chairmanPhotoRedirect">Chairman Photo Redirect URL:</label>
          <input
            id="chairmanPhotoRedirect"
            type="url"
            value={chairmanPhotoRedirect}
            onChange={e => setChairmanPhotoRedirect(e.target.value)}
          />
        </div>

        <div className="admin-chairmanmessage-form-group">
          <label htmlFor="chairmanMessageRedirect">Chairman Message Redirect URL:</label>
          <input
            id="chairmanMessageRedirect"
            type="url"
            value={chairmanMessageRedirect}
            onChange={e => setChairmanMessageRedirect(e.target.value)}
          />
        </div>

        <button type="submit" className="admin-chairmanmessage-btn-primary">
          {editingId ? 'Update' : 'Submit'}
        </button>
        {editingId && (
          <button type="button" className="admin-chairmanmessage-btn-secondary" onClick={resetForm}>
            Cancel Edit
          </button>
        )}
      </form>

      <h3 className="admin-chairmanmessage-subtitle">Existing Chairman Messages</h3>
      <ul className="admin-chairmanmessage-message-list">
        {chairmanMessages.map(message => (
          <li key={message._id} className="admin-chairmanmessage-message-item">
            <div><strong>About Chairman:</strong> {message.aboutChairman}</div>
            <div><strong>Chairman Message:</strong> {message.chairmanMessage}</div>
            {message.chairmanPhoto && <img src={message.chairmanPhoto} alt="Chairman" />}
            {message.chairmanMessagePhoto && <img src={message.chairmanMessagePhoto} alt="Chairman Message" />}
            {message.chairmanMessageBanner && <img src={message.chairmanMessageBanner} alt="Banner" />}
            <div className="admin-chairmanmessage-actions">
              <button onClick={() => handleEdit(message)}>Edit</button>
              <button onClick={() => handleDelete(message._id)}>Delete</button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ChairmanMessage;
